import {Component, OnInit, OnDestroy, TemplateRef, ViewChild, AfterViewInit} from '@angular/core';

declare var $: any;
import {NzModalService} from 'ng-zorro-antd';
import {takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {AuthService} from '../auth/auth.service';
import {Router} from '@angular/router';
import {
  BusinessInfoService,
  InteractionsService,
  NotificationsService,
  RootService,
  BusinessResolver, BusinessCodeService
} from '../services';
import {AccountInfoService} from 'src/app/services/business/account-info/account-info.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {environment} from '../../environments/environment';
import * as io from 'socket.io-client';
import {json} from 'ng2-validation/dist/json';
import {AngularFireDatabase} from '@angular/fire/database';

@Component({
  selector: 'app-business',
  templateUrl: './business.component.html',
  styleUrls: ['./business.component.scss']
})
export class BusinessComponent implements OnInit, OnDestroy, AfterViewInit {
  business;
  account;
  nameAccount;
  isCollapsed = true;
  isVisible = false;
  changeTab = false;
  unsubscribe$ = new Subject<void>();
  socket: any;
  listNotify = [];
  pageIndexNotify = 1;
  loadingNotify = true;
  countNotify = 0;
  notifyNew;
  countLocal = 0;
  unread = 0;
  // tslint:disable-next-line:variable-name
  glns_id = [];
  totalGln = 0;
  pageIndex = 1;
  pageSize = 50;
  list = [];
  total = 0;
  query;
  // @ts-ignore
  @ViewChild('template') template;
  // @ts-ignore
  @ViewChild('message') message;
  constructor(
    private modalService: NzModalService,
    private authService: AuthService,
    private router: Router,
    private rootService: RootService,
    private accountService: AccountInfoService,
    private notification: NzNotificationService,
    private  businessInfoService: BusinessInfoService,
    private interactionsService: InteractionsService,
    private notificationsService: NotificationsService,
    private db: AngularFireDatabase,
    private businessResolver: BusinessResolver,
    private businessCodeService: BusinessCodeService,
  ) {

  }

  ngOnInit() {
    this.accountService.currentName.pipe(takeUntil(this.unsubscribe$)).subscribe(
      name => {
        this.loadInfoAccount();
      }
    );
    this.businessInfoService.currentName.pipe(takeUntil(this.unsubscribe$)).subscribe(
      name => {
        this.loadInfoBusiness();
      }
    );
    /*Socket*/

    this.notificationsService.countNotify().pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.countNotify = res.data.total;
    });


    this.socketRealtime();
    /*End Socket*/

    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.$jquery();
    this.listenChange();

    this.loadDataNotify(this.pageIndexNotify);
    this.numberMess();
    this.businessInfoService.currentMessage.pipe(takeUntil(this.unsubscribe$)).subscribe(
      async res => {
        this.loadGln();
        // if (this.router.url !== '/business/chat' && this.list.length) {
        //   // this.notification.template(this.message, {nzDuration: 5000});
        //   }
      }
    );
  }

  loadInfoAccount() {
    this.accountService.info().pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
          this.account = res.data;
          let fistName = '';
          let lastName = '';
          if (res.data.fistName !== null) {
            fistName = res.data.fistName;
          }
          if (res.data.lastName !== null) {
            lastName = res.data.lastName;
          }
          this.nameAccount = fistName + ' ' + lastName;
          const currentUser = JSON.parse(localStorage.getItem('currentUser'));
          const user = Object.assign(currentUser, {role: res.data && res.data.role ? res.data.role : null});
          localStorage.setItem('currentUser', JSON.stringify(user));
        }
      }
    );
  }

  loadInfoBusiness() {
    this.businessInfoService.getInfoBusiness().pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        this.business = res.data;
        console.log('getInfoBusiness', this.business);
      }
    );
  }

  redirectMObio() {
    this.notification.config({
      nzDuration: 5000
    });
    this.businessInfoService.validateMobio().pipe(takeUntil(this.unsubscribe$)).subscribe(
      res => {
        if (res.code === 1) {
         if (res.data === true) {
           const user = this.authService.currentUserValue;
           window.open(`https://test1.mobio.vn/login?token=${user.token}&source=icheck&lang=vi`, 'blank');
           return;
         }
         this.notification.error(
            'Tài khoản của bạn chưa được đăng ký sử dụng dịch vụ Mobio',
            'Vui lòng liên hệ bộ phận CSKH iCheck để được hỗ trợ. Hotline: 0902.195.488 - Email: hotro@icheck.vn'
          );
         return;
        }
        this.notification.error(
          'Tài khoản của bạn chưa được đăng ký sử dụng dịch vụ Mobio',
          'Vui lòng liên hệ bộ phận CSKH iCheck để được hỗ trợ. Hotline: 0902.195.488 - Email: hotro@icheck.vn'
        );
      },
      error => {
        this.notification.error(
          'Có lỗi xảy ra',
          error.message
        );
      }
    );
  }

  selectBusiness() {
    const currentUser = this.authService.currentUserValue;
    if (!currentUser.isAdmin) {
      this.notification.error(
        'Thất bại',
        'Tài khoản của bạn không có quyền truy cập vào trang này'
      );
      return;
    }
    this.router.navigate(['/support-business']);
  }

  logout() {
    this.authService.logout();
    this.notification.create(
      'success',
      'Thành công',
      'Đăng xuất thành công'
    );
  }

  $jquery() {
    $('.selected-user').click((event) => {
      event.stopPropagation();

      if (!$(event.target).closest($('.box-notify')).length && !$(event.target).closest('.selected-notify').length) {
        $('.box-notify').removeClass('opened');
      }

      $('.icon-down-user').toggleClass('flip');
      // $('.box-user').toggle();
      $('.box-user').toggleClass('opened');
    });

    $('.box-user').click(() => {
      $('.icon-down-user').removeClass('flip');
      $('.box-user').removeClass('opened');
    });

    $(window).click((event) => {
      $('.icon-down-user').removeClass('flip');

      if (!$(event.target).closest($('.box-user')).length && !$(event.target).closest('.selected-user').length) {
        $('.box-user').removeClass('opened');
      }
    });

    $('.selected-notify').click((event) => {
      event.stopPropagation();
      if (!$(event.target).closest($('.box-user')).length && !$(event.target).closest('.selected-user').length) {
        $('.icon-down-user').removeClass('flip');
        $('.box-user').removeClass('opened');
      }

      $('.box-notify').toggleClass('opened');
    });
    //
    // $('.content-notify-box').click(() => {
    //   $('.box-notify').removeClass('opened');
    // });

    $(window).click((event) => {
      if (!$(event.target).closest($('.box-notify')).length && !$(event.target).closest('.selected-notify').length) {
        $('.box-notify').removeClass('opened');
      }
    });

    /* Load more*/


    /*Notify*/
    $('.scrollpane').scroll(() => {
      const $this = $('.scrollpane');
      // tslint:disable-next-line:prefer-const
      let $results = $('.content-notify-box');

      // if (!$results.data("loading")) {

      // tslint:disable-next-line:triple-equals
      // tslint:disable-next-line:radix
      if (Math.round($this.scrollTop()) + Math.round($this.height()) === Math.round($results.height())) {
        this.pageIndexNotify += 1;

        // Tính scoll khi nhận quá(bằng) 7 notify
        if (this.countLocal >= 7) {
          this.pageIndexNotify += this.countLocal % 7;
        }
        this.countLocal = 0;

        this.loadDataNotify(this.pageIndexNotify);
      }
      // }
    });
  }

  createBasicNotification(): void {
    // this.notification.config({
    //   nzDuration: 4500
    // });
    // this.notification.template(this.template);
    this.notification.template(this.template, {nzDuration: 5000});
    // setTimeout(() => {
    //   this.notification.remove();
    //   this.notification.config({
    //     nzPlacement: 'bottomRight'
    //   });
    // }, 4500);
  }

  closeNotify() {
    $('.box-notify').removeClass('opened');
  }

  loadDataNotify(pageIndex) {
    const query = {
      page: pageIndex,
      page_size: 7
    };
    this.notificationsService.listNotify(query).pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res.data.items.length !== 0) {
        res.data.items.map((value) => {
          if (this.listNotify.length > 0) {
            const check = this.listNotify.some(element => element.id === value.id && element.createdAt === value.createdAt);
            if (check !== true) {
              this.listNotify.push(value);
            }
          } else {
            this.listNotify.push(value);
          }
        });

      } else {

        this.pageIndexNotify -= 1;
        this.loadingNotify = false;

      }

    });
  }

  seenAll() {

    this.notificationsService.seenAll().pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
        this.countNotify = 0;
        this.listNotify.map((res2) => {
          res2.status = 1;
        });
      },
      error => {
        this.notification.create(
          'error',
          'Thất bại',
          'Đã có lỗi xảy ra'
        );
      });

  }


  seenNotify(id, path, status, type?) {
    if (status === 0) {
      this.notificationsService.seenNotify(id).pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
          this.countNotify -= 1;
          // this.router.navigate([path]);
          this.router.navigateByUrl(path);
          // this.router.navigate(['/business/shops/detail/AJYLw9Pr?barcode=97182381231233']);
          this.listNotify.filter(res2 => {
            if (res2.id === id) {
              res2.status = 1;
            }
          });
        },
        error => {
          this.notification.create(
            'error',
            'Thất bại',
            'Đã có lỗi xảy ra'
          );
        });
    } else {
      // this.router.navigateByUrl('/business/shops/detail/AJYLw9Pr?barcode=97182381231233&isOwner=1');
      this.router.navigateByUrl(path);
      // this.router.navigate([path]);
    }
    if (type === 'noneNotify') {
      $('.ant-notification-notice-close-x').click();
    }
  }

  /*End Notify*/

  /*changeMenu*/
  changeMenu() {
    this.changeTab = !this.changeTab;
    this.listenChange();
  }

  listenChange() {
    if (this.changeTab === true) {
      this.isCollapsed = false;
    } else {
      this.isCollapsed = true;
      this.rootService.currentMessage.pipe(takeUntil(this.unsubscribe$)).subscribe(message => {
        if (this.changeTab === true) {
          this.isCollapsed = false;
        } else {
          this.isCollapsed = message;
        }
      });
    }
  }

  /*End changeMenu*/

  /*Socket*/

  // @ts-ignore
  listen(eventName: string) {
    return new Observable((subscriber) => {
      this.socket.on(eventName, (data) => {
        subscriber.next(data);
      });
    });
  }

  socketRealtime() {
    // tslint:disable-next-line:prefer-const
    let token = JSON.parse(localStorage.getItem('currentUser')).token;
    this.socket = io(`${environment.url_socketio}`, {secure: true});
    this.socket.emit('REG', token);

    /*REALTIME*/
    this.listen('ACTION-LOGGING').pipe(takeUntil(this.unsubscribe$)).subscribe((base64) => {
      // console.log('444', base64);
      this.rootService.scanChangeMessage(base64);
    });

    /*NOTIFI*/
    this.listen('NOTIFI').pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      this.countLocal += 1;
      if (typeof res === 'string') {
        const data = JSON.parse(this.b64_to_utf8(JSON.parse(res).data));
        const notify = {
          id: data.id,
          title: data.title,
          content: data.message,
          type: data.type,
          path: data.path,
          createdAt: data.createdAt,
          status: data.status,
        };
        this.countNotify += 1;
        this.listNotify.unshift(notify);
        this.notifyNew = notify;
        this.createBasicNotification();
      }
    });

    // // tslint:disable-next-line:no-shadowed-variable
    this.listen('connect').pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.rootService.disconnetStatus(false);
    });
    this.listen('disconnect').pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.rootService.disconnetStatus(true);
    });

    this.rootService.connectIoMessage.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.socket.connect();
    });
  }

  b64_to_utf8(str) {
    return decodeURIComponent(escape(window.atob(str)));
  }

  /*End Socket*/

  loadGln() {
    this.query = {
      page: this.pageIndex,
      page_size: this.pageSize
    };
    // this.businessCodeService.getGlnOfChat(this.query).pipe(takeUntil(this.unsubscribe$)).subscribe(
    //   async res => {
    //     if (res.code === 1) {
    //       // tslint:disable-next-line:variable-name
    //       const list_id = [];
    //       await this.list.map(
    //         li => {
    //           list_id.push(li.id);
    //         }
    //       );
    //       this.total = res.data.totalElement;
    //       await res.data.items.map(
    //         item => {
    //           if (!list_id.includes(item.id)) {
    //             this.list.push(item);
    //             // this.getStatusRead(item.id);
    //           }
    //         });
    //       const totalPage = Math.ceil(this.total / this.pageSize);
    //       if (this.pageIndex < totalPage) {
    //         this.pageIndex = this.pageIndex + 1;
    //         this.loadGln();
    //       }
    //       if (this.list.length === this.total + 1) {
    //         this.getStatusRead();
    //       }
    //     }
    //   }
    // );
  }
  // Mess
  getStatusRead() {
    const promise = [];
    this.list.map(item => {
      promise.push(
        new Promise((resolve, reject) => {
          this.db.object(`/users/i-${item.id}`).valueChanges().pipe(takeUntil(this.unsubscribe$)).subscribe(res => {
            resolve(res);
          });
        })
      );
    });
    Promise.all(promise).then(
      async res => {
        const array = [];
        await res.map(r => {
          if (r !== null && r.unreadCount) {
            array.push(r);
          }
        });
        const unreads = [];
        await array.map(a => {
          const rooms = a.unreadRooms;
          const totalRooms = [];
          if (rooms !== undefined) {
            // tslint:disable-next-line:forin
            Object.values(rooms).map( i => {
              if (i > 0) {
                totalRooms.push(i);
              }
            });
          }
          // if (a.unreadCount === totalRooms.length) {
          //   unreads.push(a);
          // }
          if (totalRooms.length) {
            unreads.push(a);
          }
        });
        this.unread = unreads.length ? unreads.length : 0;
      },
    );
  }

  playSound() {
    const audio = new Audio();
    audio.src = '../../../../assets/sound.mp3';
    audio.load();
    audio.play();
  }

  numberMess() {
    this.loadGln();
  }

  // end message
  redirectChat() {
    this.router.navigate(['/business/chat']);
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  saveAsImage(parent) {
    const parentElement = parent.qrcElement.nativeElement
      .querySelector('canvas')
      .toDataURL('image/png');

    const blobData = this.convertBase64ToBlob(parentElement);

    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE
      window.navigator.msSaveOrOpenBlob(blobData, 'Qrcode');
    } else { // chrome
      const blob = new Blob([blobData], { type: 'image/png' });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Qrcode';
      link.click();
    }

  }

  private convertBase64ToBlob(Base64Image: any) {
    const parts = Base64Image.split(';base64,');
    const imageType = parts[0].split(':')[1];
    const decodedData = window.atob(parts[1]);
    const uInt8Array = new Uint8Array(decodedData.length);
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: imageType });
  }
  isShowAgain = false;
  isShowModalQRCode = false;

  onCloseQRCode() {
    this.isShowModalQRCode = false;
    localStorage.setItem('isShowModalQRCode', String(this.isShowModalQRCode));
  }

  dataChanged(val) {
    // console.log("val", val);
    this.isShowAgain = val;
    localStorage.setItem('isShowAgain', String(!this.isShowAgain));
  }

  ngAfterViewInit(): void {
    const isShowAgain = JSON.parse(localStorage.getItem('isShowAgain'));
    // console.log("isShowAgainxxx", isShowAgain);
    if (isShowAgain !== null) {
      this.isShowAgain = !isShowAgain;
    }

    if (isShowAgain || isShowAgain === null) {
      this.isShowModalQRCode = true;
    }
  }

  onRedirectQRMKT() {
    window.open(environment.redirect_QRMKT, '_blank');
  }
}
